/**
 * Cacule la position et la taille de la zone de travaille suivant le facteur de zoom de l'editeur
 * @param {Number} formatWidth la taille du format de travail
 * @param {Number} formatHeight la hauteur du format de travail
 * @param {Canvas} canvas l'objet canvas de FabricJs
 * @return {Object} Les dimension et le positionnement de la zone de travaille
 */
const getWorkSpaceSize = (formatWidth, formatHeight, canvas) => {
  const p = {
    x: canvas.getCenter().left,
    y: canvas.getCenter().top
  }
  const m = canvas.viewportTransform
  const width = formatWidth * m[0]
  const height = formatHeight * m[3]
  const x = p.x - width / 2
  const y = p.y - height / 2
  return {
    x,
    y,
    width,
    height
  }
}

/**
 * Centre l'objet via le viewport
 * @param {canvas} canvas l'objet fabric js canvas
 * @param {Object} target l'objet a centrer
 */
const centerObject = (canvas, target) => {
  canvas.viewportCenterObject(target)
  target.setCoords()
}

export { centerObject, getWorkSpaceSize }



// WEBPACK FOOTER //
// ./src/model/pixel/tools/WorksSpace.js